import { Faq, Lang } from '@owl-nest/api-client/latest'
import * as i18n from './i18n'

export const getAnswer = (faq: Faq, lang: Lang): string => {
  return i18n.get(faq.answer, lang, '')
}

export const getQuestion = (faq: Faq, lang: Lang): string => {
  return i18n.get(faq.question, lang, '')
}
